var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useState } from 'react';
import { useTheme } from '../Theme/ThemeProvider';
import combineClassNames from '../../css/combineClassNames';
export const BUTTON_KEY = 'button';
export const TEXT_KEY = 'text';
const getAnalyticsClass = (analytics) => {
    switch (analytics) {
        case 'button':
            return 'stat-button-link';
        case 'text':
            return 'stat-text-link';
        default:
            return '';
    }
};
const Button = (_a) => {
    var { variant = 'primary', inverted, className, analytics, children, onClick } = _a, props = __rest(_a, ["variant", "inverted", "className", "analytics", "children", "onClick"]);
    const theme = useTheme();
    const [styles, setStyles] = useState(null);
    useEffect(() => {
        import(`./styles/${theme}.scss`).then((styles) => {
            setStyles(styles);
        });
    }, []);
    return (React.createElement(React.Fragment, null, styles && (React.createElement("button", Object.assign({ className: combineClassNames('cv-button', `cv-button--${variant}${inverted ? '-inverted' : ''}`, getAnalyticsClass(analytics), className), onClick: onClick }, props), children))));
};
export default Button;
//# sourceMappingURL=Button.js.map